// extracted by mini-css-extract-plugin
export var link = "SocialButtons-module--link--2fc4d";
export var icon = "SocialButtons-module--icon--68d26";